import React, { useEffect, useState } from 'react';
import ProfileDetails from './ProfileDetails';
import CustomerPreferences from './CustomerPreferences';
import RecentInteractions from './RecentInteractions';
import ProductOverview from './ProductOverview';
import CustomerCards from './CustomerCards';
import CreditOverview from './CreditOverview';
import CustomerInvestments from './CustomerInvestments';
import userData from '../../data/userData.json';

const CustomerOverview = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [filteredCustomer, setFilteredCustomer] = useState([]);

  useEffect(() => {
    if(searchQuery){
      const filtered = userData.filter(customer => 
        customer['Customer Name'].toLowerCase().includes(searchQuery.toLowerCase()) ||
        customer['Customer ID'].toString().includes(searchQuery)
      );
      setFilteredCustomer(filtered)
    }else{
      setFilteredCustomer([]);
    }
  }, [searchQuery])

  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
    setSearchQuery('');
    setFilteredCustomer([]);
  }

  return (
    <div className="p-6 space-y-6">
      <div className="w-full">
        <div className="relative">
          <input
            type="text"
            placeholder="Search Customer Database..."
            className="w-full p-4 rounded-xl border bg-[#2A2A2A] border-[#3A3A3A] text-[#FFFFFF] placeholder-[#B0B0B0] focus:outline-none focus:border-[#B4E50D] focus:ring-2 focus:ring-[#B4E50D] focus:ring-opacity-20 transition-all duration-200"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="absolute right-3 top-4 text-[#B0B0B0]">
            🔍
          </div>
        </div>
        
        {filteredCustomer.length > 0 && (
          <div className="mt-2 bg-[#1A1A1A] rounded-lg border border-[#2A2A2A] max-h-60 overflow-y-auto">
            {filteredCustomer.map(customer => (
              <div
                key={customer['Customer ID']}
                className = 'p-3 hover:bg-[#2A2A2A] cursor-pointer border-b border-[#2A2A2A] last:border-b-0 transition-colors'
                onClick = {() => handleCustomerSelect(customer)}
              >
                <div className="text-[#FFFFFF] font-medium">{customer['Customer Name']}</div>
                <div className="text-sm text-[#B0B0B0]">ID: {customer['Customer ID']} • {customer['Client Segment']}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedCustomer && (
          <>
            <div className="flex items-center justify-between">
              <h1 className="text-3xl font-bold text-[#FFFFFF]">Customer Overview</h1>
              <div className="text-sm text-[#B0B0B0]">
                Last updated: {new Date().toLocaleDateString()}
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <ProfileDetails customer = {selectedCustomer}/>
              <CustomerCards customer = {selectedCustomer}/>
              <RecentInteractions customer = {selectedCustomer}/>
            </div>

            <h2 className="text-2xl font-bold mt-8 text-[#FFFFFF]">Product Overview</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <ProductOverview customer = {selectedCustomer}/>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
              <CreditOverview customer = {selectedCustomer}/>
            </div>

            <div className="grid grid-cols-1 gap-6">
              <CustomerInvestments customer = {selectedCustomer}/>
            </div>
          </>
        )
      }

      {!selectedCustomer && (
        <div className="text-center py-20">
          <div className="text-6xl mb-4">👥</div>
          <h2 className="text-2xl font-bold text-[#FFFFFF] mb-2">Search for a Customer</h2>
          <p className="text-[#B0B0B0]">Use the search bar above to find and select a customer to view their details</p>
        </div>
      )}
    </div>
  );
};

export default CustomerOverview;